import { FaChartLine, FaRupeeSign, FaBullseye, FaUtensils, FaBan, FaFileInvoice } from 'react-icons/fa';

function FrameworkSection({ buyLink, onBuyClick }) {
  const features = [
    {
      icon: <FaChartLine className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Complete Payment Recovery System",
      subtitle: ""
    },
    {
      icon: <FaRupeeSign className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Positive Cash Flow",
      subtitle: ""
    },
    {
      icon: <FaBullseye className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Zero Bad Debt in 6 months",
      subtitle: ""
    },
    {
      icon: <FaUtensils className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Pani Puri Model",
      subtitle: "Payment Strategy"
    },
    {
      icon: <FaBan className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "No Part Payments Culture",
      subtitle: "Full Payment Policy"
    },
    {
      icon: <FaFileInvoice className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Per Invoice Payment System",
      subtitle: "Individual Invoice Tracking"
    }
  ];

  return (
    <section className="relative py-24 px-4 sm:px-8 bg-slate-800 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* Title */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white text-center mb-6 drop-shadow-lg">
          Credit Control System
        </h1>
        <p className="text-lg sm:text-xl lg:text-2xl text-slate-400 text-center mb-10 max-w-3xl mx-auto font-medium">
          A comprehensive system designed to transform your payment collection process
        </p>
        
        {/* Big Bold Statement */}
        {/* <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-yellow-500 to-orange-500 drop-shadow-2xl leading-snug">
            11 Unbeatable Laws of Payment Recovery
          </h2>
        </div> */}

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8 lg:gap-10 max-w-[1200px] mx-auto">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-7 sm:p-9 lg:p-11 text-center border border-amber-500/20 hover:border-amber-500/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.4),0_8px_10px_-6px_rgba(0,0,0,0.4)]"
            >
              {/* Icon */}
              <div className="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 mx-auto mb-5 sm:mb-7 rounded-2xl bg-amber-500/15 flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-300">
                {feature.icon}
              </div>

              {/* Title */}
              <div className="text-lg sm:text-xl lg:text-2xl text-white font-extrabold mb-2 leading-tight">
                {feature.title}
              </div>
              
              {/* Subtitle */}
              {feature.subtitle && (
                <div className="text-base sm:text-lg text-slate-400 font-medium">
                  {feature.subtitle}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FrameworkSection;
